export default {
  glow: {
    active: 'Aktiv',
    blankText: '(tom)',
    cancel: 'Annuller',
    clearAll: 'Ryd alle',
    close: 'Luk',
    confirm: 'Bekræfte',
    copied: 'Kopieret',
    copyFailed: 'Kopiering mislykkedes',
    copyValue: 'Kopier {{value}}',
    deselectAll: 'Fravælg alle',
    dismiss: 'Afvis',
    event: {
      serviceUpgrade: {
        title: 'Serviceopgradering',
        curbside: 'Levering til kantsten',
        indoor: 'Indbæring',
        deliveryDate: 'Leveringsdato'
      },
      shorterTimeWindow: {
        title: 'Kortere tidsvindue'
      }
    },
    emptyStates: {
      notFoundTitle: 'Ingen resultater',
      notFoundDescription: 'Vi kunne ikke finde nogen resultater. Juster din søgefilter, og prøv igen.',
      initialTitle: 'Ingen information endnu',
      successTitle: 'Godt klaret!'
    },
    goToPage: 'Gå til side',
    group: 'Gruppe',
    from: 'Fra',
    filter: 'Filter',
    filterOverlay: {
      filter: 'Filter',
      activeFilterCount: '{{count}} aktivt filter',
      activeFilterCount_other: '{{count}} aktive filtre',
      clearFilter: 'Ryd filter'
    },
    invalidDateFormat: 'Ugyldigt datoformat',
    openCalendar: 'Åbn kalenderen',
    loading: 'Indlæser',
    no: 'Nej',
    none: 'Intet valg',
    notActivated: 'Ikke aktiveret',
    of: 'af',
    orderOfTable: 'Rækkefølge af kolonneoverskrifter',
    orderOfTableDescription: 'Vælg den foretrukne rækkefølge for kolonneoverskrifterne ved at trække og slippe.',
    fixedTableHeadersDescription: 'Følgende kolonneoverskrifter er faste og kan ikke fjernes eller omarrangeres.',
    page: 'side',
    search: 'Søg',
    settings: 'Indstillinger',
    selectAll: 'Vælg alle',
    selectAllCount: 'Vælg alle ({{count}})',
    selectAllOnPage: 'Vælg alt på siden ({{count}})',
    to: 'Til',
    yes: 'Ja',
    accordionMessage: {
      error: '{{count}} fejlmeddelelser',
      warning: '{{count}} advarselsmeddelelser',
      info: '{{count}} informationsmeddelelser',
      general: '{{count}} meddelelser'
    },
    invalidRegistrationNumber: 'Angiv et gyldigt registreringsnummer, der kun indeholder bogstaver og tal',
    invalidRegistrationNumber_SE: 'Ugyldigt format. Forventet: ABC123 eller ABC12D',
    invalidRegistrationNumber_DK: 'Ugyldigt format. Forventet: AB12345',
    invalidRegistrationNumber_NO: 'Ugyldigt format. Forventet: AB1234 eller AB12345'
  }
}
